import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const partnerTypes = [
  { title: "503A Compounding Pharmacies", desc: "Partner with Apexum to access qualified clinical demand from licensed providers across multiple states." },
  { title: "503B Outsourcing Facilities", desc: "Connect with clinic operators seeking compliant outsourcing facility pathways for office-use products." },
  { title: "Lab Partners", desc: "Provide diagnostic and specialty lab services to Apexum's network of performance-health and hormone clinics." },
  { title: "Telehealth Infrastructure", desc: "Power the telehealth platform needs of clinic operators building hybrid or virtual-first care models." },
  { title: "Fulfillment Partners", desc: "Handle patient-specific and cold-chain fulfillment for clinic networks at scale." },
  { title: "Medical Director Networks", desc: "Provide licensed medical director support to clinic organizations building compliant care models." },
];

export default function ForPartners() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="pt-28 pb-16 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-blue-600 mb-4">For Partners</p>
          <h1 className="text-5xl font-medium text-slate-900 mb-5" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Partner with Apexum
          </h1>
          <p className="text-xl text-slate-600 mb-8">
            Apexum connects qualified clinical demand with trusted backend partners across pharmacy, lab, telehealth, fulfillment, and performance-health infrastructure.
          </p>
          <Link to="/talk-to-ava"
            className="inline-flex items-center gap-2 bg-blue-600 text-white px-8 py-3.5 rounded-full font-medium hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/25">
            Apply as a Partner <ArrowRight size={18} />
          </Link>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-3xl font-medium text-slate-900 text-center mb-12" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Partner categories
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {partnerTypes.map((p, i) => (
              <div key={i} className="bg-white rounded-3xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-6 hover:-translate-y-1 transition-transform duration-300">
                <h3 className="font-semibold text-slate-900 mb-2 text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>{p.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-3xl p-8 text-center border border-blue-100">
            <h3 className="text-2xl font-medium text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Ready to join the Apexum network?
            </h3>
            <p className="text-slate-600 mb-6 max-w-lg mx-auto">
              Select "Pharmacy/Vendor Partner" as your role when speaking with AvA to begin the partner onboarding process.
            </p>
            <Link to="/talk-to-ava"
              className="inline-flex items-center gap-2 bg-blue-600 text-white px-8 py-3.5 rounded-full font-medium hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/25">
              Talk to AvA <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
